import { render, staticRenderFns } from "./AupairTalksTopics.vue?vue&type=template&id=246609a3&"
import script from "./AupairTalksTopics.vue?vue&type=script&lang=js&"
export * from "./AupairTalksTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports